// extracted by mini-css-extract-plugin
export default {"waveContainer":"WaveBreak_waveContainer__BcH62","waveTop":"WaveBreak_waveTop__G9zHj","waveBottom":"WaveBreak_waveBottom__la889"};